const updateFundersReportDateRange = function ({ commit }, payload) {
  commit("SET_FUNDER_REPORT_DATE_RANGE", payload);
};

export default updateFundersReportDateRange;
